module.exports = __webpack_public_path__ + "img/icon-checkmark-gray2.ec2b6067.svg";